import { render } from "./TransitionExpand.vue?vue&type=template&id=4fd945ad&scoped=true&ts=true"
import script from "./TransitionExpand.vue?vue&type=script&lang=ts"
export * from "./TransitionExpand.vue?vue&type=script&lang=ts"

import "./TransitionExpand.vue?vue&type=style&index=0&id=4fd945ad&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fd945ad"]])

export default __exports__